import { render, staticRenderFns } from "./CreationsOverview.vue?vue&type=template&id=632cbf9f&scoped=true"
import script from "./CreationsOverview.vue?vue&type=script&lang=js"
export * from "./CreationsOverview.vue?vue&type=script&lang=js"
import style0 from "./CreationsOverview.vue?vue&type=style&index=0&id=632cbf9f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "632cbf9f",
  null
  
)

export default component.exports